import React, {useState, useEffect} from 'react';
import {
  Flex,
  Spacer,
  FormLabel,
  Textarea,
  Stack,
  Box,
  VStack,
  Text,
  FormHelperText,
  FormErrorMessage,
  FormControl,
  Button,
  IconButton,
  Table,
  Tr,
  Td,
  Tbody,
  Divider,
  useDisclosure,
} from '@chakra-ui/react';
import {useForm} from 'react-hook-form';
import {CustomInput, CustomCheckbox, SubmitButton, CustomSelect, DatePicker, CustomIntRadioGroup, CustomButton} from '../../General/FormInputs';
import SurveyTypes from '../Cards/ServiceTypeCard';
import Ranking from '../Cards/Ranking';
import TpiBracket from '../Cards/TpiBracket';
import ListClientsBy from '../Cards/ListClientsBy';
import FlexCard from '../../General/FlexCard';
import ZipCityState from '../../General/ZipCityState';
import {Client, OpportunityPlan, Region} from '../../../service/Urls';
import {get, post, postDelete} from '../../../service/ApiService';
import ErrorHelper from '../../../service/ErrorHelper';
import Select, {components} from 'react-select';
import {useClient} from '../../../views/Maintenance/ClientMaintenance';
import {useClientOpp} from '../../../views/Maintenance/OppPlanMaintenance';
import {FaPlusSquare, FaTrashAlt} from 'react-icons/fa';
import BoxCard from '../../General/BoxCard';
import {useTitle} from '../../General/Layout';
import {isAdmin} from '../../../helpers/localStorage';
import ModalYesNo from '../../../components/General/ModalYesNo';

const OppClient = () => {
  const {client} = useClientOpp();
  const [typeChecked, setTypeChecked] = useState([]);
  const [surveyChecked, setSurveyChecked] = useState([]);
  const [rankingChecked, setRankingChecked] = useState([]);
  const [invalids, setInvalids] = useState([false, false, false, false]);
  const [ranges, setRanges] = useState([]);
  const [delRanges, setDelRanges] = useState([]);
  const [title, setTitle] = useTitle('Opportunity Plan Maintenance');
  const [months, setMonths] = useState([
    {name: 'January', value: 'January'},
    {name: 'February', value: 'February'},
    {name: 'March', value: 'March'},
    {name: 'April', value: 'April'},
    {name: 'May', value: 'May'},
    {name: 'June', value: 'June'},
    {name: 'July', value: 'July'},
    {name: 'August', value: 'August'},
    {name: 'September', value: 'September'},
    {name: 'October', value: 'October'},
    {name: 'November', value: 'November'},
    {name: 'December', value: 'December'},
  ]);
  const [plan, setPlan] = useState(null);
  const [options, setOptions] = useState([]);
  const [elements, setElements] = useState({});
  const [readOnly, setReadOnly] = useState(true);
  const [toast, setToast] = useState('');
  const [isSalesMan, setIsSalesMan] = useState(true);
  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: {errors},
  } = useForm({defaultValues: plan});
  const {isOpen: isOpenZeroARModal, onOpen: onOpenZeroARModal, onClose: onCloseZeroARModal} = useDisclosure();

  const colors = ['red.500', 'orange.500', 'yellow.500', 'green.500', 'blue.500', 'purple.500'];

  useEffect(() => {
    if (isAdmin()) {
      setIsSalesMan(false);
    }
  }, []);

  useEffect(async () => {
    if (client?.client?.clId) {
      setRanges([]);
      setReadOnly(false);
      const response = await get(OpportunityPlan.GET_BY_ID + '/' + client.client.id);
      response.clArbal = response.clArbal ?? 0;
      response.clThres = response.clThres ?? 0;
      response.clRrthis = response.clRrthis ?? 0;
      response.clRredt = response?.clRredt ? response.clRredt.substring(0, response.clRredt.indexOf('T')) : '';
      response.clRrsdt = response?.clRrsdt ? response.clRrsdt.substring(0, response.clRrsdt.indexOf('T')) : '';
      setPlan(response);
      const res = await get(OpportunityPlan.RECORD + '/' + response.id + '/ranges');
      setRanges(res.data);

      setTypeChecked([
        response.clFuneral ?? false,
        response.clCremat ?? false,
        response.clCemet ?? false,
        response.clMonu ?? false,
        response.clPreneed ?? false,
        response.clPet ?? false,
        response.clEvent ?? false,
      ]);
      setSurveyChecked([
        client.client.clActive ?? false,
        response.clUsecont ?? false,
        response.clRrrev ?? false,
        response.clRrtot ?? false,
        response.clRrall ?? false,
        response.clRrfd ?? false,
      ]);
      setReadOnly(false);
    }
  }, [client?.client]);

  useEffect(() => {
    reset(plan);
  }, [plan]);

  useEffect(() => {
    setElements(prevState => ({
      ...prevState,
      rangers:
        ranges == [] || ranges === undefined
          ? []
          : ranges.map((ra, idx) => {
              return (
                <Tr key={idx}>
                  <Td w="25%">
                    <Box borderRadius="md" bg="black" px="3" py="2.5">
                      <Text w="100%" color={colors[idx % 6]}>
                        Range {idx + 1}
                      </Text>
                    </Box>
                  </Td>
                  <Td>
                    <CustomInput
                      register={register}
                      requireInt={true}
                      type="number"
                      min="0"
                      max="10000"
                      errors={errors}
                      w="100%"
                      mx="0"
                      defaultValue={ra.nrangelow}
                      id={ra.nSeq + '.nrangelow'}
                      bg="yellow.500"
                      isReadOnly={readOnly}
                    />
                  </Td>
                  <Td>
                    <CustomInput
                      register={register}
                      min="0"
                      requireInt={true}
                      type="number"
                      max="10000"
                      errors={errors}
                      w="100%"
                      mx="0"
                      defaultValue={ra.nrangehigh}
                      id={ra.nSeq + '.nrangehigh'}
                      bg="yellow.500"
                      isReadOnly={readOnly}
                    />
                  </Td>
                  <Td>
                    <CustomInput
                      register={register}
                      min="-100"
                      requireInt={true}
                      type="number"
                      max="100"
                      errors={errors}
                      w="100%"
                      mx="0"
                      defaultValue={ra.nrangepct}
                      id={ra.nSeq + '.nrangepct'}
                      bg="yellow.500"
                      isReadOnly={readOnly}
                    />
                  </Td>
                  <Td>
                    <IconButton bg="orange.500" title="Delete" size="md" mt="-0.5" icon={<FaTrashAlt />} onClick={() => rangeDelete(idx)} />
                  </Td>
                </Tr>
              );
            }),
    }));
  }, [ranges]);

  const onSubmit = async data => {
    if (isSalesMan) {
      setToast({response: {error: 1}, errorMessage: 'Invalid Permissions'});
      return;
    }
    const cl = {
      id: plan.id,
      clTarget: 0,
      clArbal: 0,
      clArdays: 0,
      clThres: 0,
      clCostper: 0,
      clUsear: true,
      clUseeo: true,
      clLocar: true,
      clFiscal: 'string',
      clNoopp: true,
      clMincall: 0,
      clCalls: 0,
      clOpp: 0,
      clUsear1: 0,
      clUseeo1: 0,
      clLocar1: 0,
      clBiann: 0,
      clFuneral: true,
      clCremat: true,
      clCemet: true,
      clMonu: true,
      clPreneed: true,
      clPet: true,
      clEvent: true,
      clPtper: 0,
      clRrate: 0,
      clRrrev: true,
      clRrtot: true,
      clRrded: 0,
      clRrall: true,
      clRrfd: true,
      clUsecont: true,
      clRrsdt: '2022-07-14T13:42:25.489Z',
      clRredt: '2022-07-14T13:42:25.489Z',
      clRrthis: 0,
      clComment: 'string',
      clientId: client.client.id,
    };
    if (!invalids[0] && !invalids[1] && !invalids[2] && !invalids[3]) {
      for (const key in cl) {
        if (data.hasOwnProperty(key)) {
          if (data[key] != null) {
            if (cl[key] == '' || cl[key] == '' || cl[key].length == 0 || (cl[key] !== true && cl[key] !== false)) {
              cl[key] = data[key];
            }
            for (let x = 0; x < data[key].length; x++) {
              if (cl[key].includes(' ')) {
                cl[key] = cl[key].trim();
              }
            }

            if (data[key] === undefined) cl[key] = data[key];
            if (!isNaN(cl[key]) && cl[key] === 0) cl[key] = 648237648234;
            if (cl[key] == '' || cl[key] === '') cl[key] = null;
            if (!isNaN(cl[key]) && cl[key] == 648237648234) cl[key] = 0;
          }
        } else {
          cl[key] = null;
        }
      }

      cl.clFuneral = typeChecked[0];
      cl.clCremat = typeChecked[1];
      cl.clCemet = typeChecked[2];
      cl.clMonu = typeChecked[3];
      cl.clPreneed = typeChecked[4];
      cl.clPet = typeChecked[5];
      cl.clEvent = typeChecked[6];
      cl.clActive = surveyChecked[0];
      cl.clUsecont = surveyChecked[1];
      cl.clRrrev = surveyChecked[2];
      cl.clRrtot = surveyChecked[3];
      cl.clRrall = surveyChecked[4];
      cl.clRrfd = surveyChecked[5];

      console.log(cl, plan);

      const response = await post(OpportunityPlan.RECORD + '/' + plan.id + '/update', cl);

      for (const key in cl) {
        if (cl.hasOwnProperty(key)) {
          if (cl[key] == null) {
            cl[key] = '';
          }
        }
      }
      cl.clArbal = cl.clArbal ?? 0;
      cl.clThres = cl.clThres ?? 0;
      cl.clRrthis = cl.clRrthis ?? 0;
      let repS = true;
      const ras = [];
      ranges.forEach(ran => {
        const ra = {...ran};
        ra.nrangelow = data[ra.nSeq].nrangelow ?? 0;
        ra.nrangehigh = data[ra.nSeq].nrangehigh ?? 0;
        ra.nrangepct = data[ra.nSeq].nrangepct ?? 0;
        ras.push(ra);
      });

      delRanges.forEach(async ra => {
        console.log(await postDelete(OpportunityPlan.RECORD + '/' + plan.id + '/ranges/' + ra.id));
      });
      setDelRanges([]);
      ras.map(async (ra, idx) => {
        ra.nSeq = idx + 1;
        if (ra?.id) {
          const res = await post(OpportunityPlan.RECORD + '/' + plan.id + '/ranges/' + ra.id, ra);
          if (!res.isSuccess) repS = false;
        } else {
          const res = await post(OpportunityPlan.RECORD + '/' + plan.id + '/ranges/add', ra);
          if (!res.isSuccess) repS = false;
        }
      });

      if (response.isSuccess && repS) {
        setPlan(cl);
        setRanges(ras);
        setToast({response: response, successMessage: 'Successfully updated plan'});
      }
    }
  };

  const zeroAR = async () => {
    onCloseZeroARModal();
    const response = await post(OpportunityPlan.RECORD + '/' + plan.id + '/zero-ar');
    setToast({response: response, successMessage: 'Successfully zero-ed ' + client.client.clCname});
    const rep = await get(OpportunityPlan.RECORD + '/' + plan.id);
    setPlan(rep);
  };

  const fixChecks = (e, idx = NaN, set = NaN) => {
    if (e.hasOwnProperty('target')) {
      if (!isNaN(idx)) {
        if (set == 0) {
          const checks = [...surveyChecked];
          checks[idx] = e.target.checked;
          setSurveyChecked(checks);
        } else if (set == 1) {
          const checks = [...typeChecked];
          checks[idx] = e.target.checked;
          setTypeChecked(checks);
        } else if (set == 2) {
          const checks = [...rankingChecked];
          checks[idx] = e.target.checked;
          setRankingChecked(checks);
        }
      } else {
        const date = e.target.value;
        setDate(date);
      }
    }
  };

  const addRange = () => {
    const ras = [...ranges];
    ras.push({nrangelow: 0, nrangehigh: 0, nrangepct: 0, nSeq: ranges[ranges.length - 1]?.nSeq ? ranges[ranges.length - 1].nSeq + 1 : 1});
    setRanges(ras);
  };

  const rangeDelete = idx => {
    const rng = [...ranges];
    const del = [...delRanges];
    if (rng[idx]?.id) del.push(rng.splice(idx, 1)[0]);
    setRanges(rng);
    setDelRanges(del);
  };

  return (
    <form w="100%" onSubmit={handleSubmit(onSubmit)}>
      <Flex w="90%" flexDir={{base: 'column', lg: 'row'}}>
        <Box w="100%">
          <FlexCard>
            <Box w="100%">
              <Flex w="100%">
                <CustomInput
                  id="clCname"
                  w="100%"
                  isReadOnly={true}
                  defaultValue={client?.client?.clCname ? client.client.clCname : ''}
                  name="Account Name"
                  register={register}
                  errors={errors}
                />
                <CustomInput
                  id="clRep"
                  w="100%"
                  isReadOnly={true}
                  defaultValue={client?.client?.clRep ? client.client.clRep : ''}
                  name="Account Rep"
                  register={register}
                  errors={errors}
                  required
                />
                <CustomCheckbox
                  name="Inactive"
                  isReadOnly={true}
                  control={control}
                  isChecked={surveyChecked[0]}
                  initial={surveyChecked[0] ? 1 : 0}
                  onChange={e => fixChecks(e, 0, 0)}
                  id="clActive"
                  mt="7"
                  w=""
                />
              </Flex>
              <Divider my="2" mt="4" />
              <Flex>
                <Flex flexDirection="column">
                  <Flex mt="2" w="100%">
                    <FormLabel htmlFor="clArbal" mt="1" ml="1" fontSize="sm">
                      A/R Balance
                    </FormLabel>
                    <Spacer />
                    <CustomInput
                      register={register}
                      requireInt={true}
                      type="number"
                      min="0"
                      max="10000"
                      errors={errors}
                      w="20"
                      id="clArbal"
                      isReadOnly={readOnly}
                    />
                  </Flex>

                  <Flex mt="2" w="100%">
                    <FormLabel htmlFor="clArdays" mt="1" ml="1" fontSize="sm">
                      A/R Days
                    </FormLabel>
                    <Spacer />
                    <CustomInput
                      register={register}
                      requireInt={true}
                      type="number"
                      min="0"
                      max="10000"
                      errors={errors}
                      w="20"
                      id="clArdays"
                      isReadOnly={readOnly}
                    />
                  </Flex>

                  <Flex mt="2" w="100%">
                    <FormLabel htmlFor="clTarget" mt="1" ml="1" fontSize="sm">
                      Target Rev/Call
                    </FormLabel>
                    <Spacer />
                    <CustomInput
                      register={register}
                      requireInt={true}
                      type="number"
                      min="0"
                      errors={errors}
                      w="20"
                      id="clTarget"
                      isReadOnly={readOnly}
                    />
                  </Flex>

                  <Flex mt="2" w="100%">
                    <FormLabel htmlFor="arbal" mt="1" ml="1" fontSize="sm">
                      Revenue Treshold
                    </FormLabel>
                    <Spacer />
                    <CustomInput
                      register={register}
                      requireInt={true}
                      type="number"
                      min="0"
                      max="10000"
                      errors={errors}
                      w="20"
                      id="clThres"
                      isReadOnly={readOnly}
                    />
                  </Flex>

                  <Flex mt="2" w="100%">
                    <FormLabel htmlFor="clCostper" mt="1" ml="1" fontSize="sm">
                      Cost Factor
                    </FormLabel>
                    <Spacer />
                    <CustomInput
                      register={register}
                      requireInt={true}
                      type="number"
                      min="0"
                      max="10000"
                      errors={errors}
                      w="20"
                      id="clCostper"
                      isReadOnly={readOnly}
                    />
                  </Flex>

                  <Flex mt="2" w="100%">
                    <FormLabel htmlFor="clMincall" mt="1" ml="1" fontSize="sm">
                      Min Calls Per Qtr
                    </FormLabel>
                    <Spacer />
                    <CustomInput
                      register={register}
                      requireInt={true}
                      type="number"
                      min="0"
                      max="10000"
                      errors={errors}
                      w="20"
                      id="clMincall"
                      isReadOnly={readOnly}
                    />
                  </Flex>

                  <Flex mt="2" w="100%">
                    <FormLabel htmlFor="clCalls" mt="1" ml="1" fontSize="sm">
                      Calls Current Qtr
                    </FormLabel>
                    <Spacer />
                    <CustomInput
                      register={register}
                      requireInt={true}
                      type="number"
                      min="0"
                      max="10000"
                      errors={errors}
                      w="20"
                      id="clCalls"
                      isReadOnly={readOnly}
                    />
                  </Flex>

                  <Flex mt="2" w="100%">
                    <FormLabel htmlFor="clPtper" mt="1" ml="1" fontSize="sm">
                      Pivot Percent
                    </FormLabel>
                    <Spacer />
                    <CustomInput
                      register={register}
                      requireInt={true}
                      type="number"
                      min="0"
                      max="10000"
                      errors={errors}
                      w="20"
                      id="clPtper"
                      isReadOnly={readOnly}
                    />
                  </Flex>
                </Flex>
                <Spacer />
                <Flex flexDirection="column">
                  <Flex mt="2" w="100%">
                    <FormLabel htmlFor="clOpp" mt="1" ml="1" fontSize="sm">
                      Opportunity Plan
                    </FormLabel>
                    <Spacer />
                    <CustomIntRadioGroup
                      mr="10"
                      control={control}
                      list={[
                        {key: 'Yes', value: 1},
                        {key: 'No', value: 2},
                      ]}
                      id="clOpp"
                      name="clOpp"
                      isReadOnly={readOnly}
                      defaultValue={plan == null ? 0 : plan.hasOwnProperty('clOpp') ? plan.clOpp : 2}
                    />
                  </Flex>
                  <Flex mt="2" w="100%">
                    <FormLabel htmlFor="clUsear1" mt="1" ml="1" fontSize="sm">
                      Use A/R
                    </FormLabel>
                    <Spacer />
                    <CustomIntRadioGroup
                      mr="10"
                      control={control}
                      list={[
                        {key: 'Yes', value: 1},
                        {key: 'No', value: 2},
                      ]}
                      id="clUsear1"
                      name="clUsear1"
                      isReadOnly={readOnly}
                      defaultValue={plan == null ? 0 : plan.hasOwnProperty('clUsear1') ? plan.clUsear1 : 2}
                    />
                  </Flex>
                  <Flex mt="2" w="100%">
                    <FormLabel htmlFor="clUseeo1" mt="1" ml="1" fontSize="sm">
                      Use E&O
                    </FormLabel>
                    <Spacer />
                    <CustomIntRadioGroup
                      mr="10"
                      control={control}
                      list={[
                        {key: 'Yes', value: 1},
                        {key: 'No', value: 2},
                      ]}
                      id="clUseeo1"
                      name="clUseeo1"
                      isReadOnly={readOnly}
                      defaultValue={plan == null ? 0 : plan.hasOwnProperty('clUseeo1') ? plan.clUseeo1 : 2}
                    />
                  </Flex>
                  <Flex mt="2" w="100%">
                    <FormLabel htmlFor="clLocar1" mt="1" ml="1" fontSize="sm">
                      Need Loc A/R
                    </FormLabel>
                    <Spacer />
                    <CustomIntRadioGroup
                      mr="10"
                      control={control}
                      list={[
                        {key: 'Yes', value: 1},
                        {key: 'No', value: 2},
                      ]}
                      id="clLocar1"
                      name="clLocar1"
                      isReadOnly={readOnly}
                      defaultValue={plan == null ? 0 : plan.hasOwnProperty('clLocar1') ? plan.clLocar1 : 2}
                    />
                  </Flex>
                  <Flex mt="2" w="100%">
                    <CustomSelect w="100%" register={register} errors={errors} id="clFiscal" name="Fiscal Year End">
                      {!client?.client?.id
                        ? []
                        : months.map(mo => {
                            return (
                              <option key={mo.value} value={mo.value}>
                                {mo.name}
                              </option>
                            );
                          })}
                    </CustomSelect>
                  </Flex>
                  <Flex mt="2" w="100%">
                    <FormLabel htmlFor="clBiann" mt="1" ml="1" fontSize="sm">
                      Bi-Annual
                    </FormLabel>
                    <Spacer />
                    <CustomIntRadioGroup
                      mr="10"
                      control={control}
                      list={[
                        {key: 'Yes', value: 1},
                        {key: 'No', value: 2},
                      ]}
                      id="clBiann"
                      name="clBiann"
                      isReadOnly={readOnly}
                      defaultValue={plan == null ? 0 : plan.hasOwnProperty('clBiann') ? plan.clBiann : 2}
                    />
                  </Flex>
                  <CustomCheckbox
                    w="100%"
                    isReadOnly={readOnly}
                    control={control}
                    id="clUsecont"
                    isChecked={surveyChecked[1]}
                    initial={surveyChecked[1] ? 1 : 0}
                    onChange={e => fixChecks(e, 1, 0)}
                    name="Use Contract Date for Opp Plan"
                  />
                </Flex>
              </Flex>
            </Box>
          </FlexCard>

          <FlexCard>
            <Box w="100%">
              <Flex>
                <Flex flexDirection="column">
                  <CustomInput
                    register={register}
                    requireInt={true}
                    type="number"
                    min="0"
                    max="10000"
                    errors={errors}
                    id="clRrate"
                    name="Return Rate"
                    isReadOnly={readOnly}
                  />
                  <CustomInput
                    register={register}
                    requireInt={true}
                    type="number"
                    min="0"
                    max="100"
                    errors={errors}
                    id="clRrded"
                    name="% to Deduct"
                    isReadOnly={readOnly}
                  />
                </Flex>
                <Spacer />

                <Flex flexDirection="column">
                  <CustomCheckbox
                    w="100%"
                    isReadOnly={readOnly}
                    control={control}
                    isChecked={surveyChecked[2]}
                    initial={surveyChecked[2] ? 1 : 0}
                    onChange={e => fixChecks(e, 2, 0)}
                    id="clRrrev"
                    name="Deduct From Revenue Portion"
                  />
                  <CustomCheckbox
                    w="100%"
                    isReadOnly={readOnly}
                    control={control}
                    isChecked={surveyChecked[3]}
                    initial={surveyChecked[3] ? 1 : 0}
                    onChange={e => fixChecks(e, 3, 0)}
                    id="clRrtot"
                    name="Deduct From Total"
                  />
                  <CustomCheckbox
                    w="100%"
                    isReadOnly={readOnly}
                    control={control}
                    isChecked={surveyChecked[4]}
                    initial={surveyChecked[4] ? 1 : 0}
                    onChange={e => fixChecks(e, 4, 0)}
                    id="clRrall"
                    name="All Employees"
                  />
                  <CustomCheckbox
                    w="100%"
                    isReadOnly={readOnly}
                    control={control}
                    isChecked={surveyChecked[5]}
                    initial={surveyChecked[5] ? 1 : 0}
                    onChange={e => fixChecks(e, 5, 0)}
                    id="clRrfd"
                    name="Only FDs"
                  />
                </Flex>
                <Spacer />
                <Flex flexDirection="column">
                  <DatePicker isReadOnly={readOnly} id="clRrsdt" name="Start Date" register={register} errors={errors} />
                  <DatePicker isReadOnly={readOnly} id="clRredt" name="End Date" register={register} errors={errors} />
                  <CustomInput
                    register={register}
                    requireInt={true}
                    type="number"
                    min="0"
                    max="100"
                    errors={errors}
                    id="clRrthis"
                    name="Return Rate This Period"
                    isReadOnly={readOnly}
                  />
                </Flex>
              </Flex>
            </Box>
          </FlexCard>

          <FlexCard>
            <Box w="100%">
              <FormLabel htmlFor="clComment" mb="-0.5" ml="1" fontSize="sm">
                Comments
              </FormLabel>
              <Textarea placeholder="Comment" id="clComment" {...register('clComment')} isReadOnly={readOnly} />
            </Box>
          </FlexCard>

          {!isSalesMan && (
            <FlexCard>
              <SubmitButton name="Save" />
              <Spacer mx="2" />
              <CustomButton name="Zero A/R" onClick={onOpenZeroARModal} />
            </FlexCard>
          )}

          <ModalYesNo
            isOpen={isOpenZeroARModal}
            onOpen={onOpenZeroARModal}
            onClose={onCloseZeroARModal}
            title="Confirmation"
            body={'Are you sure you want to Zero A/R?'}
            yesFunction={() => zeroAR()}
          />
        </Box>

        {/** Stack of all the cards on the right hand side */}
        <Flex flexDirection="column" ml="2" w="55%">
          <Box bgGradient={'linear(to-tr, blue.600, blue.200)'} boxShadow="2xl" rounded="lg" border="1px" p="2" px="30" mb="2">
            <Text fontWeight="bold" fontSize="3xl">
              Survey Types
            </Text>
            <Flex justify="space-evenly">
              <Flex flexDirection="column">
                <CustomCheckbox
                  w="100%"
                  control={control}
                  isChecked={typeChecked[0]}
                  initial={typeChecked[0] ? 1 : 0}
                  onChange={e => fixChecks(e, 0, 1)}
                  id="clFamily"
                  name="Funeral"
                  isReadOnly={readOnly}
                />
                <CustomCheckbox
                  w="100%"
                  control={control}
                  isChecked={typeChecked[1]}
                  initial={typeChecked[1] ? 1 : 0}
                  onChange={e => fixChecks(e, 1, 1)}
                  id="clCremat"
                  name="Cremation"
                  isReadOnly={readOnly}
                />
                <CustomCheckbox
                  w="100%"
                  control={control}
                  isChecked={typeChecked[2]}
                  initial={typeChecked[2] ? 1 : 0}
                  onChange={e => fixChecks(e, 2, 1)}
                  id="clCemet"
                  name="Cemetery"
                  isReadOnly={readOnly}
                />
                <CustomCheckbox
                  w="100%"
                  control={control}
                  isChecked={typeChecked[3]}
                  initial={typeChecked[3] ? 1 : 0}
                  onChange={e => fixChecks(e, 3, 1)}
                  id="clMonu"
                  name="Monument"
                  isReadOnly={readOnly}
                />
              </Flex>
              <Flex flexDirection="column">
                <CustomCheckbox
                  w="100%"
                  control={control}
                  isChecked={typeChecked[4]}
                  initial={typeChecked[4] ? 1 : 0}
                  onChange={e => fixChecks(e, 4, 1)}
                  id="clPreneed"
                  name="PreNeed"
                  isReadOnly={readOnly}
                />
                <CustomCheckbox
                  w="100%"
                  control={control}
                  isChecked={typeChecked[5]}
                  initial={typeChecked[5] ? 1 : 0}
                  onChange={e => fixChecks(e, 5, 1)}
                  id="clPet"
                  name="Pet Cremation"
                  isReadOnly={readOnly}
                />
                <CustomCheckbox
                  w="100%"
                  control={control}
                  isChecked={typeChecked[6]}
                  initial={typeChecked[6] ? 1 : 0}
                  onChange={e => fixChecks(e, 6, 1)}
                  id="clEvent"
                  name="Event Planning"
                  isReadOnly={readOnly}
                />
              </Flex>
            </Flex>
          </Box>
          <Box bgGradient={'linear(to-tr, yellow.600, yellow.200)'} boxShadow="2xl" rounded="lg" border="1px" p="2">
            <Text fontWeight="bold" fontSize="3xl">
              Call Brackets
            </Text>
            <Box>
              <Table className="tableCard">
                <Tbody>
                  <Tr>
                    <Td></Td>
                    <Td>
                      <Box borderRadius="md" bg="black" color="white" py="3">
                        <Text>Lower</Text>
                      </Box>
                    </Td>
                    <Td>
                      <Box borderRadius="md" bg="black" color="white" py="3">
                        <Text>Higher</Text>
                      </Box>
                    </Td>
                    <Td>
                      <Box borderRadius="md" bg="black" color="white" py="3">
                        <Text>Percent</Text>
                      </Box>
                    </Td>
                    <Td>
                      <IconButton bg="orange.500" title="Delete" size="md" mt="-1.5" icon={<FaPlusSquare />} onClick={() => addRange()} />
                    </Td>
                  </Tr>
                  {elements.rangers}
                </Tbody>
              </Table>
            </Box>
          </Box>
          {/* <ListClientsBy /> */}
        </Flex>
      </Flex>
      <ErrorHelper toastResponse={toast} />
    </form>
  );
};

export default OppClient;
